import { ApolloClient, InMemoryCache } from '@apollo/client';
import { GQL_DOMAIN } from '@launchos/shared-utils/env';

export const client = new ApolloClient({
  uri: GQL_DOMAIN,
  cache: new InMemoryCache(),
  // Enable sending cookies over cross-origin requests
  // credentials: 'include'
});